module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('br'), _vm._v(" "), _c('el-tabs', [(!_vm.isProjectView()) ? _c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-chart-pie"
  }), _vm._v(" Sites & Operations")]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Sites")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 14,
      "md": 16,
      "lg": 12
    }
  }, [_c('sites-chart', {
    attrs: {
      "show-legend": false,
      "stats": _vm.stats
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 10,
      "md": 8,
      "lg": 8
    }
  }, [_c('sites-stats-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)], 1), _vm._v(" "), (_vm.canAccess('project|maintenance|management|admin') && _vm.stats.actions && _vm.stats.tickets && !_vm.isProjectView()) ? _c('div', [_c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Operations")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('op-stats', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('management|project|maintenance|finance|admin')) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Sharer Summary")]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Sharers")])]), _vm._v(" "), _c('sharer-report', {
    attrs: {
      "show-ways": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTelco() || _vm.canAccess('project|finance|maintenance|admin')) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Request Files")]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Request Files")])]), _vm._v(" "), _c('files-request-table')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" General Summary")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e98da03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/views/GeneralSummary.vue
// module id = 1522
// module chunks = 0